import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import {Observable, throwError, from} from "rxjs";
import {KeycloakService} from "./keycloak.service";
import {Injectable} from "@angular/core";
import {LoaderService} from "./loading-bar/loader.service";
import {catchError, map, switchMap} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class TokenInterceptor implements HttpInterceptor {

  private requests: HttpRequest<any>[] = []; // Store pending requests

  constructor(private kcService: KeycloakService, private loaderService: LoaderService) {
  }

  private removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1); // remove request from array
    }
    // Show loading bar if there is still a request loading
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.kcService.getToken();
    
    // Skip token for login requests
    if (request.url.includes('/protocol/openid-connect/token')) {
      return next.handle(request);
    }

    if (authToken) {
      request = request.clone({
        setHeaders: {'Authorization': 'Bearer ' + authToken}
      });
    }

    this.loaderService.isLoading.next(true);
    this.requests.push(request);

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.removeRequest(request);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.removeRequest(request);
        
        if (error.status === 401) {
          // Token might be expired, try to refresh
          return from(this.kcService.updateToken()).pipe(
            switchMap(() => {
              // Retry the request with new token
              const newToken = this.kcService.getToken();
              const newRequest = request.clone({
                setHeaders: {'Authorization': 'Bearer ' + newToken}
              });
              return next.handle(newRequest);
            })
          );
        }
        return throwError(error);
      })
    );
  }
}
